import React from "react";
import Paper from "@material-ui/core/Paper"

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import WorkorderService from "../../services/workorders";

class WorkorderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, uniqueUsers: [] };
  }

  render() {
    let items = [];
    let usersIDs = this.props.items.map((item) => { return item.user.firstname + ' ' + item.user.lastname });
    let uniqueIDs = usersIDs.filter(function (x, i, a) {
      return a.indexOf(x) === i;
    });

    if (uniqueIDs.length > 1 && this.props.status ===3) {
      for (let i = 0; i < uniqueIDs.length; i++) {
        let filteredItems = this.props.items.filter((item) => { return item.user.firstname + ' ' + item.user.lastname === uniqueIDs[i] });
        let userItems = filteredItems.map(item => {
          let showUserInfo = false;
          if (item.user && this.props.showUserInfo) {
            showUserInfo = true;
          }
          return (
            <React.Fragment key={item._id} >
              <ListItem key={item._id} onClick={e => { this.props.handleEdit(item); }} >
                <ListItemText primary={showUserInfo ? (item.user.firstname + ' ' + item.user.lastname + ' - ' + item.name) : item.name} secondary={WorkorderService.getStatusLabel(item.status)} />
              </ListItem><br style={{clear:'both'}}/>
            </React.Fragment>
          );
        })
        items.push(
          <ExpansionPanel key={uniqueIDs[i]}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
           {uniqueIDs[i]}
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>

             <div style={{width:'100%'}}>{userItems}</div> 
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )
      }
    } else {
      items = this.props.items.map(item => {
        let showUserInfo = false;
        if (item.user && this.props.showUserInfo) {
          showUserInfo = true;
        }
        return (
          <React.Fragment key={item._id} >
            <ListItem key={item._id} onClick={e => { this.props.handleEdit(item); }} >
              <ListItemText primary={showUserInfo ? (item.user.firstname + ' ' + item.user.lastname + ' - ' + item.name) : item.name} secondary={WorkorderService.getStatusLabel(item.status)} />
            </ListItem>
          </React.Fragment>
        );
      });
    }


    return (


      <Paper >
        <List>{items}</List>
        {this.props.items.length === 0
          &&
          <div className="padding">Geen werkbonnen aanwezig</div>
        }
      </Paper>

    );
  }
}
export default WorkorderList;
